// find the percentage of the point that a user have out of 250 points
//when 250 is reached, the rolled over points begin again at 0 in the preogress bar
import { environment } from '../../../environments/environment';
import { datadogRum } from '@datadog/browser-rum';

export function pointsInPercent(points: any) {
    let temp = 0;
    points = Number.parseInt(points);
    if (points > 250) {
        points = points - 250;
    }
    if (!Number.isNaN(points)) {
        temp = (points / 250) * 100;
    }
    return temp;
}

export function isMobile() {
    if (
        /Android|webOS|iPhone|iPod|iPad|BlackBerry|IEMobile|Opera Mini|Googlebot-Mobile/i.test(
            navigator.userAgent
        )
    ) {
        return true;
    } else {
        return false;
    }
}

export function isTablet() {
    if (/Android|Googlebot-Mobile/i.test(navigator.userAgent)) {
        return true;
    } else {
        return false;
    }
}

export function iOSVersion() {
    if (/iP(hone|od|ad)/.test(navigator.userAgent)) {
        // supports iOS 2.0 and later
        const v = navigator.userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/);
        if (v) {
            return [
                Number.parseInt(v[1], 10),
                Number.parseInt(v[2], 10),
                Number.parseInt(v[3] || '0', 10),
            ];
        } else {
            return null;
        }
    } else {
        return null;
    }
}

/**
 * This function is used to add session monitoring for the user.
 */
export function startUserSessionMonitor() {
    if (environment.production) {
        datadogRum.init({
            applicationId: '89a00c6e-3811-4540-b55d-22d71e7e8361',
            clientToken: 'pub5b13adc4a0cdf72615ba2d77b777907f',
            site: 'datadoghq.com',
            service: 'driver-dashboardfe',
            env: environment.env || 'local',
            sessionSampleRate: 100,
            sessionReplaySampleRate: 100,
            trackUserInteractions: true,
            trackResources: true,
            trackLongTasks: true,
            defaultPrivacyLevel: 'mask-user-input',
            version: window.__env?.['VERSION'] ?? environment.VERSION,
        });
        let data = localStorage.getItem('user');
        if (data) {
            const user = JSON.parse(data);
            datadogRum.setUser({
                email: user.email,
            });
        }
    }
}

/**
 * This function is used to stop the user session monitoring.
 */
export function stopUserSessionMonitor() {
    if (environment.production) {
        datadogRum.clearUser();
        datadogRum.stopSession();
    }
}

/**
 * This function is used to remove the user details from the local storage and set a new item only with the email.
 */
export function resetUserToken() {
    let userDetails = localStorage.getItem('user');
    if (userDetails) {
        const userDetailsJson = JSON.parse(userDetails);
        localStorage.setItem(
            'user',
            JSON.stringify({
                email: userDetailsJson?.email,
            })
        );
    }
}

/**
 * This function is used to convert the date string from the backend to a date object.
 *
 * @param {string} date - Date string from the backend in the format of 'YYYY-MM-DDTHH:mm:ss.ssZ'. Timezone is UTC.
 * Example: '2021-01-01T00:00:00.00Z'.
 * @returns {Date} - Date object in UTC.
 */
export function convertDate(date: string): Date | null {
    try {
        const dateOfBirthSplit = date.split('-');
        return new Date(
            Number.parseInt(dateOfBirthSplit[0]),
            Number.parseInt(dateOfBirthSplit[1]) - 1,
            Number.parseInt(dateOfBirthSplit[2])
        );
    } catch (error) {
        console.error(error);
        return null;
    }
}

/**
 * This function checks if the referredBy string indicates referral by an Uber partner.
 *
 * @param {string | null} referredBy - The referred_by string from user data.
 * @returns {boolean} - True if referred by Uber partner, false otherwise.
 */
export function isReferredByUberPartner(referredBy: string | null): boolean {
    return referredBy?.startsWith('Uber_Partner') || false;
}
